import CloseIcon from '@mui/icons-material/Close';
import { IconButton, ListItem, ListItemText, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledAutoComplete } from './StyledComponents';

const highlightMatch = (text, query) => {
   if (!text) return;

   const regex = new RegExp(`(${query})`, 'gi');
   return text.replace(regex, '<span style="background-color: yellow;">$1</span>');
};

export default function Combobox({
   id,
   options = [],
   placeholder,
   name,
   className,
   value,
   freeSolo,
   autoHighlight,
   inputHeight = "",
   getLabel = (option) => option.label,
   onChange = () => { },
}) {
   const { t } = useTranslation();
   const [inputValue, setInputValue] = useState('');

   const handleClear = () => {
      setInputValue('');
      onChange('selectedShift', null);
      onChange(name, '');
   };
   const handleOnChange = (_, newValue) => {
      onChange(newValue);
   };

   return (
      <StyledAutoComplete
         id={id}
         className={className}
         options={options}
         getOptionLabel={getLabel}
         noOptionsText={t('common.content-160')}
         value={value}
         freeSolo={freeSolo}
         autoHighlight={autoHighlight}
         renderOption={(props, option) => {
            return (
               <ListItem {...props}>
                  {/* <ListItemText primary={<div dangerouslySetInnerHTML={{ __html: highlightMatch(getLabel(option), inputValue) }} />} /> */}
                  <ListItemText
                     primary={
                        <div
                           dangerouslySetInnerHTML={{
                              __html:
                                 inputValue &&
                                    inputValue.toLowerCase() !== getLabel(option).toLowerCase()
                                    ? highlightMatch(getLabel(option), inputValue)
                                    : getLabel(option),
                           }}
                        />
                     }
                  />
               </ListItem>
            );
         }}
         inputValue={inputValue}
         onInputChange={(_, newInputValue) => {
            setInputValue(newInputValue)
         }}
         onChange={handleOnChange}
         renderInput={(params) => {
            return (
               <TextField
                  {...params}
                  placeholder={placeholder}

                  InputProps={{
                     ...params.InputProps,
                     endAdornment: (
                        <IconButton
                           onClick={handleClear}
                           disabled={!inputValue}
                           sx={{
                              position: 'absolute',
                              right: 0,
                              top: 0,
                              bottom: 0,
                              "&.Mui-disabled": {
                                 opacity: inputValue ? 1 : 0.5,
                              }
                           }}
                        >
                           <CloseIcon />
                        </IconButton>
                     ),
                  }}
                  sx={{
            "& .MuiOutlinedInput-root": {
              height: inputHeight,
              minHeight: inputHeight,
            },
            "& .MuiOutlinedInput-input": {
              height: inputHeight,
              py: 0,
              boxSizing: "border-box",
            },
          }}
               />
            );
         }}
      />
   );
}
